import "./App.css";
import MyNavbar from "./components/Navbar";
import MyFooter from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import Nx from "./components/pages/Nx";
import SolidEdge from "./components/pages/Solid-Edge";
import SolidWorks from "./components/pages/Solid-Works";
import Kontakt from "./components/pages/Kontakt";
import Impressum from "./components/pages/Impressum";
import Ehrenamt from "./components/pages/Ehrenamt";
import Referenzkunden from "./components/pages/Referenzkunden";
import SolidCAM from "./components/pages/SolidCAM";
import DreiDDruck from "./components/pages/Drei-D-Druck";

import "bootstrap/dist/css/bootstrap.min.css";
import Spezialgebiete from "./components/pages/Spezialgebiete";

function App() {
  return (
    <>
      <Router>
        <MyNavbar />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/nx" element={<Nx />} />
          <Route path="/solid-edge" element={<SolidEdge />} />
          <Route path="/solid-works" element={<SolidWorks />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/solidcam" element={<SolidCAM />} />
          <Route path="/3d-druck" element={<DreiDDruck />} />
          <Route path="/ehrenamt" element={<Ehrenamt />} />
          <Route path="/referenzkunden" element={<Referenzkunden />} />
          <Route path="/spezialgebiete" element={<Spezialgebiete />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        <MyFooter />
      </Router>
    </>
  );
}

export default App;
